import * as React from 'react';
// import GDLWidgetForm from './GDLWidgetForm';
import GDLWidgetFormNew from './GDLWidgetFormNew.js';

const App = () => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(!open);
  };

  return (
    <div>
      <button onClick={handleOpen}> {open ? "Switch GDL Widget 2.0" : "Switch GDL Widget 1.0"}</button>
      {open ? <div>
        {/* <GDLWidgetForm open={open}/> */}
      </div> :
        <div>
          <GDLWidgetFormNew open={open}/>
        </div>
    }
    </div>
  );
};

export default App;
